export default "__VITE_ASSET__NRZ6OWaW__";